import React, { useState } from 'react'

import { Modal, Form, Button } from 'semantic-ui-react'

const DesignerStaticTextPromptModal = ({ handleSubmit, setShowModal }) => {
  // States
  const [text, setText] = useState('')

  const submitForm = (e) => handleSubmit(e, { value: 'static' }, text)

  return (
    <Modal dimmer="blurring" open size="small" onClose={() => setShowModal(false)}>
      <Modal.Header>
        Static Text
      </Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <p>
            Enter the fixed text you want to display as part of your video template—something that will be
            the same no matter who submitted the video, like “brought to you by Vloggi”.
          </p>

          <Form onSubmit={submitForm}>
            <Form.Input
              autoFocus
              fluid
              type="text"
              placeholder="e.g. “brought to you by Vloggi”"
              value={text}
              onChange={(e, { value }) => setText(value)}
            />
          </Form>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setShowModal(false)}>Close</Button>
        <Button primary onClick={submitForm}>
          OK
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
export default DesignerStaticTextPromptModal
